import { Island } from '../island.class';
import { IslandAssetProperties } from '../types';
import { IslandType } from '../enums';
import { determineIslandTypeCfn } from './determine-island-type.cfn';

/**
 * Calculates island sku based on island width and surround material
 * @param island Island to calculate the sku for
 * @param skuData [string, IslandAssetData]
 * @returns Sku
 */
export const getIslandSkuCfn = (island: Island, skuData: [string, IslandAssetProperties]): string => {
	// Update island type based on height if needed
	determineIslandTypeCfn(island);

	const surroundCode = island.surround.code;
	const isMok = island.surround.material === 'mok';
	let islandLength = skuData[0] ?? '0';

	let typeCode1 = '';
	let typeCode2 = '';
	let typeCode3 = '';

	switch (island.type) {
		case IslandType.Pizza:
			typeCode1 = 'P';
			typeCode2 = 'P';
			islandLength = '3';
			break;
		case IslandType.Asado:
			typeCode1 = 'C';
			typeCode2 = 'K';
			typeCode3 = '';
			islandLength = '3';
			break;
		case IslandType.Smoker:
			typeCode1 = 'C';
			typeCode2 = 'C';
			typeCode3 = 'S';
			break;
		case IslandType.Corner:
			typeCode1 = 'C';
			typeCode2 = 'C';
			typeCode3 = 'C';
			islandLength = '5';
			break;
		case IslandType.Bar:
			typeCode1 = 'C';
			typeCode2 = 'C';
			typeCode3 = 'B';
			break
		default:
			typeCode1 = 'C';
			typeCode2 = 'C';
			break;
	}

	const mokPrefix = isMok ? 'M' : '';
	const sku = `RTA${typeCode1}-${typeCode2}${mokPrefix}${islandLength}${typeCode3}-${surroundCode}`;

	return sku;
};
